import { useDispatch } from 'react-redux';
import { restockSubscribe } from '@client/product/redux/restockSubscribe/redux';
import { bindActionCreators } from '@reduxjs/toolkit';

export const useRestockSubscribeAction = (): typeof restockSubscribe => {
  const dispatch = useDispatch();

  return bindActionCreators(restockSubscribe, dispatch);
};
